(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyclon-app-product"]) return;
  try {
    
(() => {
 const initialize = (scope = document) => {
  for (const gallery of scope.querySelectorAll('[data-cx-gallery]')) {
   if (gallery.dataset.cxGalleryReady) continue;
   gallery.dataset.cxGalleryReady = 'true';
   const open = gallery.querySelector('[data-cx-gallery-open]');
   const empty = gallery.querySelector('[data-cx-gallery-empty]');
   const position = gallery.querySelector('[data-cx-gallery-position]');
   const thumbs = [...gallery.querySelectorAll('[data-cx-gallery-thumb]')];
   if (!open || !empty) continue;
   const watch = image => {
    const finish = failed => {
     if (open.querySelector('img') !== image) return;
     open.hidden = failed;
     empty.hidden = !failed;
     open.setAttribute('aria-busy', 'false');
    };
    image.addEventListener('load', () => finish(false));
    image.addEventListener('error', () => finish(true));
    if (image.complete && image.currentSrc) finish(image.naturalWidth === 0);
   };
   watch(open.querySelector('img'));
   const select = index => {
    const thumb = thumbs[index];
    const image = thumb?.querySelector('template')?.content.querySelector('img')?.cloneNode(true);
    if (!image) return;
    open.setAttribute('aria-busy', 'true');
    open.hidden = false;
    empty.hidden = true;
    open.href = thumb.href;
    open.replaceChildren(image);
    watch(image);
    thumbs.forEach((item, current) => item.setAttribute('aria-pressed', String(current === index)));
    if (position) position.textContent = (index + 1) + ' / ' + thumbs.length;
   };
   thumbs.forEach((thumb, index) => {
    thumb.setAttribute('role', 'button');
    thumb.setAttribute('aria-pressed', String(thumb.getAttribute('aria-current') === 'true'));
    thumb.removeAttribute('aria-current');
    thumb.addEventListener('click', event => {
     if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
     event.preventDefault();
     select(index);
    });
    thumb.addEventListener('keydown', event => {
     if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
     if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      select(index);
      return;
     }
     let next;
     if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
     if (event.key === 'ArrowLeft') next = (index + thumbs.length - 1) % thumbs.length;
     if (event.key === 'Home') next = 0;
     if (event.key === 'End') next = thumbs.length - 1;
     if (next === undefined) return;
     event.preventDefault();
     select(next);
     thumbs[next].focus({ preventScroll: true });
     thumbs[next].scrollIntoView?.({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    });
   });
  }
 };
 initialize();
 document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyclon-builder-steps"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cy-build]').forEach(root => {
 let platform = '', intent = '';
 const show = name => {
  root.querySelectorAll('[data-screen]').forEach(screen => { screen.hidden = screen.dataset.screen !== name; });
  root.querySelector('[data-progress]').textContent = name === 'platform' ? '1 / 3' : name === 'options' ? '2 / 3' : '3 / 3';
  root.querySelector('[data-selected]').textContent = platform;
  root.querySelector('[data-summary]').textContent = platform + ' · ' + intent;
  root.querySelector('[data-platform-field]').value = platform;
  root.querySelector('[data-intent-field]').value = intent;
  root.querySelector('[data-screen="' + name + '"] h1, [data-screen="' + name + '"] h2').focus({preventScroll:true});
 };
 root.addEventListener('click', event => {
  const button = event.target.closest('button');
  if (!button) return;
  if (button.dataset.platform) { platform = button.dataset.platform; show('options'); }
  if (button.dataset.intent) { intent = button.dataset.intent; show('contact'); }
  if (button.dataset.back) show(button.dataset.back);
 });
 if(root.querySelector('[data-form-result]')) show('contact');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
